export const Clear = "Clear";
export const Defaults = "Defaults";
export const Custom = "Custom";
export const CustomUnsaved = "Custom (Unsaved)";
